import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { I18nextProvider } from 'react-i18next'
import i18n from './i18n'
import AppRoutes from './AppRoutes'
import { ToastProvider } from './components/Toast'
import './index.css'

const App: React.FC = () => (
  <I18nextProvider i18n={i18n}>
    <ToastProvider>
      <BrowserRouter basename="/">
        <AppRoutes />
      </BrowserRouter>
    </ToastProvider>
  </I18nextProvider>
)

export default App
